<template lang="pug">
  .d-flex.flex-grow-1.flex-md-grow-0.align-center.pl-lg-4
    .font-weight-bold.text-subtitle-1.text-lg-h5.pl-md-2 {{ $t("знм") }}: {{ cashRegister.serialNumber }} • {{ $t("статус") }}: {{ statusText }}
    v-btn.ml-2(icon :title="$t('выйти')" @click="signOut()")
      v-icon mdi-logout
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {

  computed: {
    ...mapState({
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
    }),

    statusText() {
      return this.$t(`cashRegister.status.${this.cashRegister.status}`)
    },
  },

  methods: {
    ...mapActions({
      signOut: 'auth/signOut',
    }),
  },
}
</script>
